const normalize = (text: string) =>
    text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

const capitalize = (text: string) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export { normalize, capitalize };
